"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("./pc"),require("./android"),require("./ios");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/platform/index.js
// module id = 1124
// module chunks = 106